import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "eval-header",
  templateUrl: "./eval-header.component.html",
  styleUrls: ["./eval-header.component.css"]
})
export class EvalHeaderComponent implements OnInit {

  @Input() evaluation;
  @Input() mode;

  constructor() { }

  ngOnInit() {
  }

}
